<template>
<!-- Report period choose -->
<pick-period-vidget
	class="py-2"
	:tiles="new Array(
		['30 днів', 30],
		['90 днів', 90],
		['6 міс', 180],
		['1 рік', 365])"
	@value="(v) => viewDaysFromNow = v"
/>

<easy-data-table
	class="data-table"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:filter-options="filterOptions"
	:rows-items="[20,40,100,300,500]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="tableHeight"
	:loading="isLoading"
	alternating
	buttons-pagination
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів журналу не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToString(time, false) }}
	</template>

</easy-data-table>
</template>


<script>
import {
	subtractHoursFromNowDate,
	dateTimeToString,
	fixNumberPrecision,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
} from '@/helpers.js'
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { usePostsStore } from '@/stores/PostsStore.js'
import { Post } from '@/models/post.js'
import { readPostReportTable } from '@/api/api.js'

export default {
	components: {
		PickPeriodVidget,
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()

		return {
			accountStore,
			postsStore,
			dateTimeToString,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
		}
	},

	data() {
		return {
			// For table period from. Hours from now.
			viewDaysFromNow: 30,
			isLoading: true,
			// Table
			rowsPerPage: 20,
			tableHeaders:[
				{ text: "Часовий період", value: "time", sortable: true, width: 160, },
				{ text: "Emin", value: "E_min" },
				{ text: "Emax", value: "E_max" },
				{ text: "Eavg", value: "E_avg" },
				{ text: "V акб.", value: "v_bat_instant" },
				{ text: "V рез акб", value: "v_backup_bat_instant" },
			],

			tableItems: [],
		}
	},

	async created() {
		this.readTableData()

		this.$watch(() => this.viewDaysFromNow, (/*newVal, oldVal*/) => {
			// Update last activity timestamp
			this.readTableData()
		})
	},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage(this.tableHeight)
	},

	methods: {
		async readTableData() {
			let rows = Array()
			
			this.isLoading = true
			// Read table rows
			//const ret = 
			await readPostReportTable(
				this.post.passport.get(Post.passportKeys.metricsId),
				subtractHoursFromNowDate(this.viewDaysFromNow * 24),
				new Date(),
				rows
			)

			//console.log("Table rows raw", rows)

			this.tableItems.length = 0
			this.isLoading = false

			// if (rows.length == 0) {
			// 	return
			// }

			// Fill table by empty rows
			const begiDate = subtractHoursFromNowDate(this.viewDaysFromNow * 24)
			begiDate.setHours(0,0,0,0)
			const stopDate = new Date()
			stopDate.setHours(0,0,0,0)
			for (var d = begiDate; d < stopDate; d.setDate(d.getDate() + 1)) {
				this.tableItems.push({
					time: new Date(d),
					E_avg: "-",
					E_max: "-",
					E_min: "-",
					v_backup_bat_instant: "-",
					v_bat_instant: "-",
				})
			}

			rows.forEach((record) => {
				try {
					// Nornalise numbers accuracy
					Object.keys(record).forEach( (key) => {record[key] = fixNumberPrecision(record[key])} )

					// Replase empty row by row from fetched array
					//
					// Read empty row
					let row = this.tableItems.find(it => {
						if (it.time.getFullYear() == record.time.getFullYear()
							&& it.time.getMonth() == record.time.getMonth()
							&& it.time.getDate() == record.time.getDate()) {
							return true
						}
					})

					// Replace row data
					Object.assign(row, record)
				} catch (error) {
					console.error("on parse post report records ", error)
				}
			})

			//console.log("Table items", this.tableItems)
		},
	},

	computed: {
		post() {return this.postsStore.post(this.postId); },

		tableHeight() { return easyDataTableHeight() - 54 },
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>
</style>